import React, { useEffect } from "react";
import { Redirect, Route, useLocation } from "react-router-dom";
import { useSelector } from "react-redux";
import NProgress from "nprogress";
import { isUserAuthenticated } from "../helpers/authUtils";

// NProgress.configure({
//   showSpinner: false,
// });

const PrivateRoute = ({ component: Component, redirectTo, roles, ...rest }) => {
  const authState = useSelector((state) => state.Auth);

  const { pathname } = useLocation();

  // useEffect(() => {
  //   if (authState.loading) {
  //     NProgress.start();
  //   }
  //   return () => NProgress.done();
  // }, [authState.loading]);

  if (authState.error) {
    return (
      <div>
        <h1 className="text-danger">ERROR</h1>
        <pre>{JSON.stringify(authState.error, null, 2)}</pre>
      </div>
    );
  }

  if (authState.loading) {
    return null;
  }

  return (
    <Route
      {...rest}
      render={(props) => {
        if (!isUserAuthenticated()) {
          // not logged in so redirect to login page with the return url
          return <Redirect to={`/user/account/login?next=${pathname}`} />;
        }

        const loggedInUser = authState?.user;
        // check if route is restricted by role
        if (
          loggedInUser &&
          roles?.length > 0 &&
          roles.indexOf(loggedInUser?.role) === -1
        ) {
          // role not authorised so redirect to home page
          return <Redirect to="/" />;
        }

        // authorised so return component
        return <Component {...props} />;
      }}
    />
  );
};

export default PrivateRoute;
